import FormInput from "../../../../../../components/Form/FormInput";
import { Instalacion } from "../../../../../../types/Instalacion";

type ModalInstalacionProp = {
    instalacionForm: Instalacion;
    setInstalacionForm: (value: Instalacion) => void;
    formErrors: any;
}

const ModalInstalacion = ({ instalacionForm, setInstalacionForm, formErrors }: ModalInstalacionProp) => {

    const handleInputChange = (e: any) => {
        const { name, value } = e.target;
        setInstalacionForm({
            ...instalacionForm,
            [name]: value
        })
    }

    return (
        <>
            <div className="row mt-2">
                <FormInput
                    id={'nombre'}
                    label={'Nombre'}
                    name={'nombre'}
                    value={instalacionForm.nombre || ''}
                    onChange={handleInputChange}
                    classLabel="col-form-label col-4 text-end"
                    classColumn="col-6"
                    errorText={formErrors.nombre}
                    maxLength={100}
                />
            </div>
            <div className="row mt-2">
                <FormInput
                    id={'domicilio'}
                    label={'Domicilio'}
                    name={'domicilio'}
                    value={instalacionForm.domicilio || ''}
                    onChange={handleInputChange}
                    classLabel="col-form-label col-4 text-end"
                    classColumn="col-6"
                    maxLength={140}
                />
            </div>
            <div className="row mt-2">
                <FormInput
                    id={'telefono'}
                    label={'Teléfono'}
                    name={'telefono'}
                    value={instalacionForm.telefono || ''}
                    onChange={handleInputChange}
                    classLabel="col-form-label col-4 text-end"
                    classColumn="col-6"
                    maxLength={24}
                />
            </div>
            <div className="row mt-2">
                <FormInput
                    id={'localidad'}
                    label={'Localidad'}
                    name={'localidad'}
                    value={instalacionForm.localidad || ''}
                    onChange={handleInputChange}
                    classLabel="col-form-label col-4 text-end"
                    classColumn="col-6"
                    maxLength={100}
                />
            </div>
        </>
    )
}

export default ModalInstalacion;
